
export default function Advantages() {
  const advantages = [
    {
      number: '01',
      icon: 'ri-home-gear-line',
      title: 'Servizio a Domicilio',
      description: 'Vengo direttamente da te, a casa o in ufficio. Risparmia tempo e goditi la comodità del servizio mobile.'
    },
    {
      number: '02',
      icon: 'ri-money-euro-circle-line',
      title: 'Prezzi Trasparenti',
      description: 'Preventivi chiari e dettagliati senza costi nascosti. Qualità professionale a prezzi competitivi.'
    },
    {
      number: '03',
      icon: 'ri-shield-check-line',
      title: 'Meccanico Certificato',
      description: 'Professionista qualificato e diplomato in Meccatronica. Competenza e affidabilità garantite.'
    }
  ];

  return (
    <section id="vantaggi" className="py-12 sm:py-16 md:py-24 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
          {advantages.map((advantage, index) => (
            <div
              key={index}
              className="relative bg-white rounded-2xl p-6 sm:p-8 md:p-12 border-l-4 border-[#E31E24] hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              {/* Large Number Background */}
              <div className="absolute top-4 sm:top-6 md:top-8 right-4 sm:right-6 md:right-8 text-6xl sm:text-7xl md:text-9xl font-black text-[#E31E24]/10 leading-none select-none">
                {advantage.number}
              </div>

              {/* Icon */}
              <div className="relative z-10 mb-10 sm:mb-14 md:mb-20">
                <i className={`${advantage.icon} text-4xl sm:text-5xl md:text-6xl text-black`}></i>
              </div>

              {/* Content */}
              <div className="relative z-10">
                <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-black mb-3 md:mb-4 group-hover:text-[#E31E24] transition-colors duration-300">
                  {advantage.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                  {advantage.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
